export const LANG_EN_DICTIONARY = {};
